// 执行时机是在初始化vue之前 可以做一些配置
// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from "vue";
import {
  Toast,
  Dialog,
  Form,
  Field,
  ActionSheet,
  Button,
  Popup,
  Loading,
  Overlay,
  Icon,
  Empty,
  Picker,
  NavBar,
  IndexBar,
  IndexAnchor,
  Search,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup,
  NoticeBar,
  ImagePreview,
  List,
  PullRefresh,
  RadioGroup,
  Radio,
  Swipe,
  SwipeItem,
  Sticky,
  TreeSelect,
  Switch,
  Tab,
  Tabs,
  Calendar,
  Collapse,
  CollapseItem,
  DropdownMenu,
  DropdownItem,
  Divider,
  Image,
  Skeleton,
  Lazyload,
  DatetimePicker
} from "vant";

Vue.prototype.$loading = text => {
  if (!text) {
    Toast.loading({ duration: 0, forbidClick: true, message: "加载中..." });
    return;
  }
  Toast.loading({ duration: 0, forbidClick: true, message: text });
};
Vue.prototype.$clear = Toast.clear;
Vue.prototype.$dialog = Dialog;
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Field);
Vue.use(ActionSheet);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Empty);
Vue.use(Picker);
Vue.use(NavBar);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Search);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NoticeBar);
Vue.use(ImagePreview);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Sticky);
Vue.use(TreeSelect);
Vue.use(Switch);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Calendar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Skeleton);
Vue.use(Lazyload);
Vue.use(DatetimePicker);
